module.exports = __webpack_public_path__ + "media/images/flags/pk-4edcdce1bed0df20b167105674c5320a.svg";